module.exports = __webpack_public_path__ + "static/media/custom-product-icon.2e8a51d4.svg";